import { mirrorX, setDefaultStyle } from "apparatus/draw";
import { DEFAULT_LIQUID_DATA, P, Segments } from "apparatus/library/common";
import { Path } from "paper";
export class WatchGlass {
    render(appearance) {
        let radius = appearance.diameter / 2;
        let height = radius / 5;
        var graphic = new Path(Segments([[radius, -height]], [[0, 0], [radius / 1.5, 0]]));
        mirrorX(graphic);
        let liquidMask = graphic.clone();
        setDefaultStyle(graphic);
        return {
            graphic: graphic,
            liquidMask: liquidMask,
            hitShape: graphic.strokeBounds.expand(10).toShape(),
            snapping: {
                type: "placeable",
                at: P(0, 2)
            }
        };
    }
}
WatchGlass.properties = {
    label: "Watch glass",
    canContainLiquids: true,
    defaultLiquidData: Object.assign(Object.assign({}, DEFAULT_LIQUID_DATA), { amountRatio: 0.0 }),
    defaultAppearance: {
        diameter: 75,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "diameter", label: "Diameter",
            min: 60, max: 100
        }
    ],
};
